export const ConsultarMetaBonusController = {}